<template>
  <div class="content">
    <div class="title">电子证件</div>
    <div class="wrapper" ref="waterMark">
      <div class="logoArea">
        <div class="schoolLogo"></div>
        <div class="schoolMotto"></div>
      </div>
      <div class="contentArea">
        <div class="left">
          <p class="name">{{ teacherData.XM }}</p>
          <p class="department">{{ teacherData.DWMC }}</p>
          <p class="tips">注意事项：</p>
          <p class="tip">1.本卡可证明本人身份，不得转借他人。</p>
          <p class="tip">2.本卡若有丢失，应即声明作废，并申请补发。</p>
          <p class="tip">3.本卡不得涂改，涂改者一律作废。</p>
          <p class="tip">4.离职时必须交回。</p>
        </div>
        <div class="right">
          <!-- <img id="headphoto" :src="teacherData.TXDZ ? teacherData.TXDZ : defaultHeadPhoto" alt=""> -->
          <img
            id="headphoto"
            :src="
              teacherData.TXDZ ? 'data:image/jpg;base64,'+ teacherData.TXDZ : require('@/assets/zhicheng/default.png')
            "
            alt=""
          />
          <p class="jobNum">工号{{ teacherData.GH }}</p>
        </div>
      </div>
    </div>
    <div class="qrcodeArea">
      <div class="barcodeimg" :class="this.isFangda ? 'fangda' : ''">
        <svg id="barcode" @click="fangda" style="width: 100%"></svg>
      </div>
      <!-- <p class="tip">用于学校图书馆</p> -->
      <div class="qrimg">
        <!-- <tki-qrcode
			    ref="qrcode"
			    :val="val"
			    :size="size"
			    :unit="unit"
				:onval="onval"
			    :loadMake="loadMake"
				@change="navToEnlargeImage"
			    /> -->
        <div id="qrCode" ref="qrCodeDiv" @click="navToEnlargeImage" :class="this.qrBig?'qrBig':''"></div>
      </div>
      <!-- <div class="foot">
				<p>用于学校图书馆出入口，出示二维码进行事项办理</p>
			</div> -->
    </div>
  </div>
</template>

<script>
import Watermark from "../../../utils/warterMark";
import JsBarcode from "jsbarcode";
import QRCode from "qrcodejs2";
import { getTeacherElectronicDocuments } from "@/api/zhicheng.js";
import Base64 from "../../../utils/base64.js";

// var Base64 = require("js-base64").Base64;
export default {
  //   components: { tkiQrcode, tkiBarcode, watermark },
  data() {
    return {
      teacherData: {},
      defaultHeadPhoto: "@/assets/zhicheng/default.png", // 默认头像
      val: "", //二维码值 学号
      barcodeValue: "", //条形码 S + 学号
      size: 127, //二维码大小
      unit: "px", //二维码大小的单位
      loadMake: true, //加载动画
      onval: true,
      opations: {
        //条形码的属性
        width: 2.5,
        height: 60,
        displayValue: false,
        marginTop: 18,
        text: "", //条形码的值 T210 + 学号
      },
      isFangda: false,
      updateTime: "",
      username: '',
      qrBig: false,
    };
  },
  created() {
    this.nowTimes();
    this.handleUrlInfo();
  },
  mounted() {
    //水印生成
    Watermark.set(this.updateTime, this.$refs.waterMark);
    this.handTeacherElectronicDocuments();
  },
  methods: {
    handTeacherElectronicDocuments() {
        let username = 'eyJhbGciOiJSUzUxMiJ9.eyJzdWIiOiIwMjEwNTgyNyIsImlzcyI6InVpcy5mZHpjeHkuZWR1LmNuIiwiQVRUUl9pZGVudGl0eVR5cGVJZCI6IjBlODc0NGMwZGZiNjExZWJiOTc2ZWE5NWZkM2RmMzQ0IiwiQVRUUl9hY2NvdW50SWQiOiIzOGVlZjBkMGUwOWUxMWViYjk3NmVhOTVmZDNkZjM0NCIsIkFUVFJfdXNlcklkIjoiMzhlMjk0YzBlMDllMTFlYmI5NzZlYTk1ZmQzZGYzNDQiLCJBVFRSX25hbWUiOiLmnpfluobmlrAiLCJBVFRSX2lkZW50aXR5VHlwZUNvZGUiOiJUMDEiLCJBVFRSX2lkZW50aXR5VHlwZU5hbWUiOiLmlZnluIgiLCJBVFRSX29yZ2FuaXphdGlvbk5hbWUiOiLorqHnrpfmnLrlt6XnqIvns7siLCJBVFRSX3VzZXJOYW1lIjoi5p6X5bqG5pawIiwiZXhwIjoxNjI5NjIwNzY1LCJBVFRSX29yZ2FuaXphdGlvbklkIjoiMjEzMDcwMDAiLCJpYXQiOjE2Mjk0NDc5NjUsImp0aSI6IklELVRva2VuLTIzOC1LLVk1Q2JaTERqU0VNOXE1d05waVpTLU4wTnNzdGFMTCIsInJlcSI6InBvcnRhbC11aSIsIkFUVFJfb3JnYW5pemF0aW9uQ29kZSI6IjIxMzA3MDAwIn0.Irm2PtUN3UiWEWKIChVxBnMUV8beuEmaWNzs52tDdJWw1U8uZTNxbqvSnLVT6isCjdQcErCr4e-2PPepb9AgPxOJSOmTH-cUL44lWhuQSesmS65piVKeuzZElj735mi3MGYcZLvt4iInpd_3dtfF-Tf7L9dptFZTuTmXVQqkvEw';
        let data ={
            username: this.username
        }
      getTeacherElectronicDocuments(data).then((res) => {
        console.log(res);
        if (res) {
          this.teacherData = res;
          this.val = res.GH; //二维码值 学号
          var mycode = "T210" + res.GH; // 条形码的值 T210 + 学号
          JsBarcode("#barcode", mycode, {
            format: "CODE128",
            lineColor: "#000",
            width: 2.5,
            height: 60,
            displayValue: false,
          });
          new QRCode(this.$refs.qrCodeDiv, {
            text: this.val,
            width: 150,
            height: 150,
            colorDark: "#333333", //二维码颜色
            colorLight: "#ffffff", //二维码背景色
            correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
          });
        }
      });
    },

    navToEnlargeImage(data) {
    //   uni.navigateTo({
    //     url: "/pages/index/enlargeImage?data=" + encodeURIComponent(data),
    //   });
        this.qrBig = this.qrBig ? false : true;
    },
    fangda() {
      this.isFangda = this.isFangda ? false : true;
    },
    nowTimes() {
      this.timeFormate(new Date());
    },
    timeFormate(timeStamp) {
      let year = new Date(timeStamp).getFullYear();
      let month =
        new Date(timeStamp).getMonth() + 1 < 10
          ? "0" + (new Date(timeStamp).getMonth() + 1)
          : new Date(timeStamp).getMonth() + 1;
      let date =
        new Date(timeStamp).getDate() < 10
          ? "0" + new Date(timeStamp).getDate()
          : new Date(timeStamp).getDate();
      let hh =
        new Date(timeStamp).getHours() < 10
          ? "0" + new Date(timeStamp).getHours()
          : new Date(timeStamp).getHours();
      let mm =
        new Date(timeStamp).getMinutes() < 10
          ? "0" + new Date(timeStamp).getMinutes()
          : new Date(timeStamp).getMinutes();
      let ss =
        new Date(timeStamp).getSeconds() < 10
          ? "0" + new Date(timeStamp).getSeconds()
          : new Date(timeStamp).getSeconds();
      this.updateTime =
        year + "/" + month + "/" + date + " " + hh + ":" + mm + ":" + ss;
    },

    handleUrlInfo() {
        let urlInfo = window.location.href;
        let urlParams = urlInfo.split("?");
        // let urlParamsList = urlParams[1].split("&");
        // this.type = urlParamsList[0].split("=")[1];
        this.username = urlParams[1].split("=")[1];
    },
  },
};
</script>

<style lang="scss" scoped>
uni-page-body {
  height: 100%;
}
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: #1374df;
  width: 100%;
  height: auto;
  min-height: 100vh;
  position: relative;
  .title {
    background: rgb(19, 116, 223);
    color: #fff;
    width: 100%;
    height: 44px;
    line-height: 44px;
    text-align: center;
  }
}

.logo {
  height: 200px;
  width: 200px;
  margin-top: 200px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 50px;
}

.text-area {
  display: flex;
  justify-content: center;
}

// .title {
//   font-size: 36px;
//   color: #8f8f94;
// }
.content .wrapper {
  width: 92%;
  min-height: 32.4%;
  background-color: #fff;
  position: relative;
  top: 15px;
  border-radius: 10px;
}
.content .wrapper .logoArea {
  width: 100%;
  margin-top: 13px;
  height: 32px;
  display: inline-flex;
  justify-content: flex-start;
  flex-direction: row;
  position: relative;
}
.content .wrapper .logoArea .schoolLogo {
  width: 204px;
  height: 32px;
  background: url(../../../assets/zhicheng/schoolLogo.png) no-repeat center;
  background-size: auto 100%;
  margin-left: 25px;
}
.content .wrapper .logoArea .schoolMotto {
  width: 106px;
  height: 23px;
  background: url(../../../assets/zhicheng/schoolMotto.png) no-repeat right;
  background-size: auto 100%;
  position: absolute;
  right: 0px;
  top: 4px;
}
.content .wrapper .contentArea {
  width: 100%;
  min-height: 138px;
  margin-top: 10px;
  position: relative;
  margin-bottom: 15px;
  /* 		display: flex;
		flex-direction: row;
		justify-content: flex-start; */
}
.content .wrapper .contentArea .left {
  width: 250px;
  height: 100%;
  padding-left: 25px;
  color: rgba(51, 51, 51, 1);
}
.left .name {
  margin-top: 10px;
  font-size: 17px;
  font-weight: 500;
}
.left .department,
.left .tips {
  font-size: 13px;
  margin-top: 5px;
}
.left .tips {
  font-size: 13px;
  margin-top: 10px;
}
.left .tip {
  font-size: 11px;
  transform: scale(0.9);
  position: relative;
  left: -13px;
}
.content .wrapper .contentArea .right {
  width: 88px;
  height: 100%;
  color: rgba(51, 51, 51, 1);
  position: absolute;
  right: 12px;
  top: 0px;
}
.right #headphoto {
  width: 84px;
  height: 115px;
}
.right .jobNum {
  font-size: 12px;
  transform: scale(0.9);
  position: relative;
  left: -3px;
  white-space: nowrap;
}
.content .qrcodeArea {
  width: 92%;
  min-height: 44.73vh;
  margin-top: 30px;
  background-color: #fff;
  border-radius: 10px;
  margin-bottom: 15px;
}
.content .qrcodeArea .barcodeimg {
  /* width: 90%; */
  margin: 0 auto;
  text-align: center;
  margin-top: 10px;
}
.content .qrcodeArea .tip {
  color: rgba(153, 153, 153, 1);
  font-size: 12px;
  text-align: center;
}
.content .qrcodeArea .qrimg {
  /* padding-left: 30%; */
  margin: 15px auto;
  text-align: center;
  display: flex;
  justify-content: center;
}
.content .qrcodeArea .foot {
  height: 40px;
  line-height: 40px;
  color: rgba(51, 51, 51, 1);
  background: #f5f5f5;
  border-radius: 0px 0px 10px 10px;
  text-align: center;
}
.foot p {
  font-size: 13px;
}
.fangda {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99999;
  width: 100% !important;
  height: 100vh;
  background-color: #fff;
}
.fangda #barcode {
  position: relative;
  margin-top: 60%;
  width: 100%;
  height: 80px;
}
.qrBig{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999999;
    width: 100%!important;
    height: 100vh;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
}
@media screen and (max-width: 320px) {
  .content .wrapper .logoArea .schoolLogo {
    width: 204px;
    height: 32px;
    background: url(../../../assets/zhicheng/schoolLogo.png) no-repeat center;
    background-size: auto 100%;
    margin-left: 0px;
    transform: scale(0.9);
    position: relative;
    left: -5px;
  }
  .content .wrapper .contentArea .left {
    padding-left: 8px;
  }
  .content .wrapper .contentArea .right {
    right: 3px;
  }
  .left .tip {
    font-size: 11px;
    -webkit-transform: scale(0.9);
    transform: scale(0.8);
    position: relative;
    left: -25px;
  }
  .barcodeimg {
    transform: scale(0.8);
  }
  .barcodeimg .tki-barcode {
    left: -20px;
  }
}
</style>